import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";

import RankingScreen from "./ranking-screen";
import {fetchRanking, resetRanking} from "../../ducks/duck-ranking";
import {getTranslation} from "../../helpers/get-translation";


function RankingScreenContainer(props) {
	return (
		<RankingScreen  {...props} language={getTranslation("language")}/>
	);
}

RankingScreenContainer.propTypes = {
	isAnonymous: PropTypes.bool.isRequired,

	activePlayerDisplayName: PropTypes.string.isRequired,
	rankingLanguage: PropTypes.string.isRequired,
	activePlayerAvatar: PropTypes.string,

	ranking: PropTypes.object.isRequired,
	isRankingLoading: PropTypes.object.isRequired,
	activePlayerStats: PropTypes.object.isRequired,

	push: PropTypes.func.isRequired,
	fetchRanking: PropTypes.func.isRequired,
	resetRanking: PropTypes.func.isRequired,
};


function mapStateToProps(state) {
	return {
		ranking: state.rankingReducer.ranking,
		isRankingLoading: state.rankingReducer.isRankingLoading,
		activePlayerStats: state.rankingReducer.activePlayerStats,
		activePlayerAvatar: state.userReducer.user.avatar,
		activePlayerDisplayName: state.userReducer.user.displayName,
		isAnonymous: state.userReducer.isAnonymous,
		rankingLanguage: state.userReducer.stats.language
	};
}

export default connect(mapStateToProps,
	{ fetchRanking, resetRanking })(RankingScreenContainer);